export default __webpack_public_path__ + "static/tax-identification-606e3d2f4bd7755a7d67d3635bd69d4e.png";